import { createContext, useContext } from 'react';
import globals from '../utils/globals';

export const FetchContext = createContext({ fetch: globals.window.fetch });

export const useFetchContext = () => useContext(FetchContext);
